import Notifications from "../../v1/components/Notifications"
import { ANCHOR_BLANK } from "../constants/common"
import store from "./configureStore"

export const copyToClipboard = async (text, t) => {
  try {
    await navigator.clipboard.writeText(text)
    store.dispatch(
      Notifications.info({
        title: t("common:copiedToClipborad"),
        position: "tr",
        autoDismiss: 3,
        action: {
          label: "Dismiss"
        }
      })
    )
  } catch (error) {
    console.log(error)
  }
}

export const openInNewTab = (url, target = ANCHOR_BLANK) => {
  const newTab = window.open(url, target, "noopener,noreferrer");
}

